import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3260_63431)",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M7.42694 9.80424C6.68918 9.80424 6.09183 10.3985 6.09183 11.1323C6.09183 11.8662 6.68918 12.4604 7.42694 12.4604C8.16469 12.4604 8.76204 11.8662 8.76204 11.1323C8.76204 10.3996 8.1758 9.80424 7.42694 9.80424Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M11.9607 9.80424C11.223 9.80424 10.6256 10.3985 10.6256 11.1323C10.6256 11.8662 11.223 12.4604 11.9607 12.4604C12.6985 12.4604 13.2959 11.8662 13.2959 11.1323C13.2959 10.3996 12.7096 9.80424 11.9607 9.80424Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M16.4946 9.80424C15.7568 9.80424 15.1594 10.3985 15.1594 11.1323C15.1594 11.8662 15.7568 12.4604 16.4946 12.4604C17.2323 12.4604 17.8297 11.8662 17.8297 11.1323C17.8297 10.3996 17.2434 9.80424 16.4946 9.80424Z" }),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 0C5.39745 0 0 4.88926 0 10.9337C0 13.9441 1.38554 16.8582 3.79347 18.9099L3.79458 18.9108C4.06833 19.1406 4.22402 19.4825 4.22402 19.844V24L8.42 21.6942C8.68778 21.5482 8.98923 21.5052 9.28328 21.5652C10.1762 21.7569 11.0886 21.8475 12 21.8475C18.6025 21.8475 24 16.9583 24 10.9138C24 4.88904 18.6023 0 12 0ZM9.32379 21.3737L9.28328 21.5652L9.28227 21.565L9.32379 21.3737ZM2.01115 10.9337C2.01115 6.03441 6.46654 2.02046 11.99 2.02046C17.5133 2.02046 21.9689 6.04421 21.9689 10.9337C21.9689 15.8234 17.5231 19.847 12 19.847C11.2246 19.847 10.4498 19.7689 9.70501 19.613C8.93922 19.444 8.13163 19.5605 7.44101 19.941L6.24515 20.5957V19.844C6.24515 18.8933 5.83094 17.9944 5.10778 17.3807C3.11109 15.6768 2.01115 13.3855 2.01115 10.9337Z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3260_63431",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
